import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadpartytokenComponent } from '../uploadpartytoken/uploadpartytoken.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { imageurl } from 'src/app/constant/constant';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup, FormArray, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';
import { Router } from '@angular/router';
import { processGenreGroups, getGenreItemsByCategory } from '../../content-creator/add-content/utils/genre-category.helper';

@Component({
    selector: 'app-create-game-invitation-modal',
    templateUrl: './create-game-invitation-modal.component.html',
    styleUrls: ['./create-game-invitation-modal.component.scss'],
    standalone: false
})
export class CreateGameInvitationModalComponent implements OnInit {
  @Input() game_id: number;
  @Input() map_id: string;
  @Input() map_name: string;
  @Input() game_details: any;
  @Input() city_id: string | number
  @Input() spawn_location: string;
  @Input() outerPartyCoordinates: any;
  map_genre: string;
  partyToken: string = '';
  loading: boolean = false;
  invitationForm: FormGroup;
  errorPartyToken: string = '';
  user_id: number;

  imageurl = imageurl;
  gamesystemlistdata: any;
  gametypelistdata: any;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private currentUserService: CurrentUserService,
    private dataService: DataService,
    private toasterService: ToastService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = parseInt(data.id);
        this.cdr.detectChanges();
      }
    });

    // Updated form with game details controls
    this.invitationForm = this.formBuilder.group({
      gameName: [this.game_details?.Gamename || '', [Validators.required]],
      gameSystem: [this.game_details?.System || '', [Validators.required]],
      map_name: [this.game_details?.map_name || ''],
      emailRows: this.formBuilder.array(
        Array.from({ length: 8 }, () => this.createEmailRow())
      ),
    });

    this.productlist();

  }

  // Custom email validator
  strictEmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) return null;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const valid = emailRegex.test(control.value);
      return valid ? null : { strictEmail: true };
    };
  }

  createEmailRow(): FormGroup {
    return this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, this.strictEmailValidator()]],
      level: [null, [Validators.min(0), Validators.required]],
      character_id: ['0'],
      game_id: [this.game_id],
      user_id: [this.user_id],
    });
  }

  get emailRows(): FormArray {
    return this.invitationForm.get('emailRows') as FormArray;
  }

  productlist() {
    this.dataService.getproductlist('gamemaster').subscribe((data: any) => {
      if (data) {
        const gameMasterProducts = data.products.gamemaster;

        // Filter game genre list from game master products
        const gameGenreList = gameMasterProducts.filter(
          (item: any) => item.type === 'game_genre'
        );

        // Group genres and filter items by selected map_genre
        const groupedGenres = processGenreGroups(gameGenreList);
        const { items } = getGenreItemsByCategory(this.map_genre, groupedGenres);

        // Update gamesystemlistdata to reflect systems associated with map_genre
        this.gamesystemlistdata = items;

        this.gametypelistdata = gameMasterProducts.filter(
          (item: any) => item.type === 'game_type'
        );
        this.cdr.detectChanges();
      }
    });
  }

  urlToBase64(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = function (error) {
        reject(error);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  uploadPartyToken(data: any) {
    const modalRef = this.modalService.open(UploadpartytokenComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.result.then((res) => {
      if (res) {
        this.partyToken = res;
        this.errorPartyToken = '';
        this.cdr.detectChanges();
      }
    });
  }

  sendEmail() {
    // Prepare game details payload
    // const gameDetails = {
    //   user_id: this.user_id,
    //   Gamename: this.invitationForm.get('gameName').value,
    //   map_id: this.map_id || null, // Not present in original, set as null
    //   // partylevel: this.invitationForm.get('totalPartyLevel').value,
    //   // Averagelevel: this.invitationForm.get('averageLevel').value,
    //   // LastPlayed: this.invitationForm.get('lastPlayed').value,
    //   // Nextgame: this.invitationForm.get('nextGame').value,
    //   gamemaster_handle: '',
    //   gamemaster_id: null, // Not present in original, set as null
    //   // game_type: '',
    //   game_system: this.invitationForm.get('gameSystem').value,
    //   spawn_location: this.spawn_location,
    //   // image: null,
    //   partytoken: this.partyToken,
    // };
    const gameDetails = {
      user_id: this.user_id,
      Gamename: this.invitationForm.get('gameName').value,
      map_id: this.map_id || null,
      spawn_city: this.city_id || '',
      gamemaster_handle: '',
      initial_party_location: this.outerPartyCoordinates || null,
      gamemaster_id: null,
      image: null,
      game_system: this.invitationForm.get('gameSystem').value,
      spawn_location: this.spawn_location,
      partytoken: this.partyToken,
    };


    // Prepare email invitations payload (unchanged logic)
    const emailRowsArray = this.emailRows.controls;
    const validRows = emailRowsArray.filter(
      (control) => control.get('email').value.trim() !== ''
    );
    const emailPayload = validRows.map((control) => control.value);

    const invalidRows = validRows.filter((control) => control.invalid);
    if (invalidRows.length > 0) {
      invalidRows.map((row) => {
        row.get('level').markAsTouched();
      })
      this.invitationForm.updateValueAndValidity();

      return;
    }
    // else if(this.partyToken.length==0){
    //  this.errorPartyToken = ' upload party token!';
    //   return;
    // }

    const emails = emailPayload.map((row) => row.email);
    const hasDuplicates = emails.some(
      (email, index) => emails.indexOf(email) !== index
    );
    if (hasDuplicates) {
      this.toasterService.showSuccess('Duplicate emails detected.', 'danger');
      return;
    }
    let payload;

    // Combine game details and email invitations into a single payload
    payload = {
      gameDetails,
      invitations: emailPayload,
    };

    if (emailPayload.length === 0) {
      payload = {
        gameDetails,
        invitations: [],
      };
    }



    if (this.invitationForm.get('gameName').valid && this.invitationForm.get('gameSystem').valid) {
      this.loading = true;
      this.dataService.sendGameAndInvitations(payload).subscribe(
        (res: any) => {
          this.loading = false;
          if (res?.data?.length > 1) {
            this.toasterService.showSuccess(res?.data[1].message, 'success');
          } else {
            this.toasterService.showSuccess('Game created and invitations sent.', 'success');
          }
          this.closeModal(res);
          this.cdr.detectChanges();
        }, (error) => {
          this.loading = false;
          this.cdr.detectChanges();
        }
      );
    }
    else {
      this.invitationForm.get('gameName').markAsTouched();
      this.invitationForm.get('gameSystem').markAsTouched();
    }


    // Note: Replace 'sendGameAndInvitations' with the appropriate DataService method based on your backend API

  }

  closeModal(data?: any) {
    this.activeModal.close(data);
  }

  backToGame() {
    this.activeModal.close();
    this.router.navigate(['/activegames']);
  }
}
